import { DateRangeBox } from 'devextreme-react';
import DataGrid, {
    Column,
    FilterRow,
    Item,
    LoadPanel,
    Scrolling,
    Sorting,
    Summary,
    Toolbar
} from 'devextreme-react/data-grid';
import { Tooltip } from 'devextreme-react/tooltip';
import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import ExportButton from '../../components/ui/ExportButton';
import api from '../../services/api-configuration';
const HalApiLogs = () => {
    const [dataSource, setDataSource] = useState([]);
    const [isAllExpanded, setIsAllExpanded] = useState(false);
    const [loading, setLoading] = useState(false);
    // Son 1 ayı default olarak ayarla
    const [dateRange, setDateRange] = useState(() => {
        const endDate = moment();
        const startDate = moment().subtract(1, 'month');
        return [startDate.toDate(), endDate.toDate()];
    });
    const [payloadModalOpen, setPayloadModalOpen] = useState(false);
    const [selectedPayload, setSelectedPayload] = useState(null);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [selectedError, setSelectedError] = useState(null);
    const [responsePayloadModalOpen, setResponsePayloadModalOpen] = useState(false);
    const [selectedResponsePayload, setSelectedResponsePayload] = useState(null);
    const [errorSummaryModalOpen, setErrorSummaryModalOpen] = useState(false);
    const [errorSummaryHtml, setErrorSummaryHtml] = useState(null);
    const [attemptCountModalOpen, setAttemptCountModalOpen] = useState(false);
    const [selectedLogForUpdate, setSelectedLogForUpdate] = useState(null);
    const [newAttemptCount, setNewAttemptCount] = useState('');
    const [updatingAttemptCount, setUpdatingAttemptCount] = useState(false);
    const [notModalOpen, setNotModalOpen] = useState(false);
    const [selectedNot, setSelectedNot] = useState(null);
    const gridRef = useRef(null);

    // Sayfa açıldığında otomatik veri çek
    useEffect(() => {
        const fetchInitialData = async () => {
            if (!dateRange || !dateRange[0] || !dateRange[1]) return;

            try {
                setLoading(true);
                const body = {
                    start_date: moment(dateRange[0]).format('YYYY-MM-DD 00:00:00'),
                    end_date: moment(dateRange[1]).format('YYYY-MM-DD 23:59:59')
                };

                const response = await api.post('/hal/getAllApiLogs', body);
                const logs = response?.data || [];
                setDataSource(logs);

                if (logs.length === 0) {
                    toast.info('Seçilen tarih aralığında log kaydı bulunamadı');
                }
            } catch (error) {
                console.error('API Log fetch error:', error);
                toast.error('Log kayıtları getirilirken hata oluştu');
                setDataSource([]);
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []); // Sadece mount olduğunda çalışsın

    const handleSearch = useCallback(async () => {
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
            toast.error('Lütfen tarih aralığı seçiniz');
            return;
        }

        try {
            setLoading(true);
            const body = {
                start_date: moment(dateRange[0]).format('YYYY-MM-DD 00:00:00'),
                end_date: moment(dateRange[1]).format('YYYY-MM-DD 23:59:59')
            };

            const response = await api.post('/hal/getAllApiLogs', body);
            const logs = response?.data || [];

            setDataSource(logs);

            if (logs.length === 0) {
                toast.info('Seçilen tarih aralığında log kaydı bulunamadı');
            }
        } catch (error) {
            console.error('API Log fetch error:', error);
            toast.error('Log kayıtları getirilirken hata oluştu');
            setDataSource([]);
        } finally {
            setLoading(false);
        }
    }, [dateRange]);

    // HTML escape helper
    const escapeHtml = (str = '') => {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    // Hatalı kayıtları mesaj tipine göre grupla
    const getLastErrorByVinPerMessageType = (logs) => {
        const groupedByType = _.groupBy(logs, 'message_type');

        return _.mapValues(groupedByType, (itemsForType) => {
            const groupedByVin = _.groupBy(itemsForType, 'vin');

            return _.chain(groupedByVin)
                .map((recordsForVin, vin) => {
                    const lastRecord = _.maxBy(
                        recordsForVin,
                        (r) => new Date(r.created_at).getTime()
                    );

                    if (lastRecord.process_status !== "SUCCESS") {
                        return {
                            vin,
                            message_type: lastRecord.message_type,
                            dealer_code: lastRecord.request_payload?.dealer_code,
                            destination_city: lastRecord.request_payload?.destination_city,
                            origin_cedi: lastRecord.request_payload?.origin_cedi,
                            response_status: lastRecord.response_status,
                            process_status: lastRecord.process_status,
                            error_detail: lastRecord.error_detail,
                            created_at: lastRecord.created_at,
                        };
                    }
                    return null;
                })
                .filter(Boolean)
                .value();
        });
    };

    // HTML email içeriği oluştur
    const buildErrorEmailHtml = (logs) => {
        const errorsByType = getLastErrorByVinPerMessageType(logs);
        const hasAnyError = Object.values(errorsByType).some(
            (arr) => Array.isArray(arr) && arr.length > 0
        );

        if (!hasAnyError) {
            return `
                <!DOCTYPE html>
                <html>
                    <head>
                        <meta charset="UTF-8" />
                        <title>HAL Hata Özeti</title>
                        <style>
                            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; color: #2c3e50; margin: 20px; background: #f5f7fa; }
                            .container { max-width: 1200px; margin: 0 auto; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
                            h2 { color: #34495e; margin: 0 0 10px 0; font-size: 20px; }
                            .info { color: #7f8c8d; margin: 10px 0; }
                        </style>
                    </head>
                    <body>
                        <div class="container">
                            <h2>HAL → UKLOJISTIK Hata Özeti</h2>
                            <p class="info">Seçilen zaman aralığında hata alınan bir kayıt bulunamadı.</p>
                        </div>
                    </body>
                </html>
            `;
        }

        // Toplam sayıları hesapla
        let totalErrors = 0;
        const typeCounts = {};
        _.forEach(errorsByType, (errorList, messageType) => {
            if (errorList && errorList.length > 0) {
                typeCounts[messageType] = errorList.length;
                totalErrors += errorList.length;
            }
        });

        let bodyContent = '';

        _.forEach(errorsByType, (errorList, messageType) => {
            if (!errorList || errorList.length === 0) return;

            const count = typeCounts[messageType] || 0;

            bodyContent += `
                <div style="margin-top: 20px; margin-bottom: 12px;">
                    <h3 style="margin: 0 0 8px 0; color: #2c3e50; font-size: 16px; font-weight: 600;">
                        ${escapeHtml(messageType)} <span style="color: #e74c3c; font-weight: 700;">(${count})</span>
                    </h3>
                </div>
                <table cellpadding="8" cellspacing="0" border="0" 
                       style="border-collapse: collapse; width: 100%; font-size: 14px; margin-bottom: 20px;">
                    <thead>
                        <tr style="background-color: #ecf0f1;">
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">VIN</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">Dealer</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">Varış Şehir</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">Origin</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: center; font-weight: 600; color: #2c3e50;">Status</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: center; font-weight: 600; color: #2c3e50;">Process</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">Tarih</th>
                            <th style="border: 1px solid #bdc3c7; padding: 8px; text-align: left; font-weight: 600; color: #2c3e50;">Hata</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            errorList.forEach((err, index) => {
                const rowBg = index % 2 === 0 ? '#ffffff' : '#f8f9fa';
                bodyContent += `
                    <tr style="background-color: ${rowBg};">
                        <td style="border: 1px solid #e0e0e0; padding: 8px; font-family: monospace; font-size: 13px;">${escapeHtml(err.vin || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px;">${escapeHtml(err.dealer_code || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px;">${escapeHtml(err.destination_city || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px;">${escapeHtml(err.origin_cedi || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px; text-align: center; color: ${err.response_status >= 400 ? '#e74c3c' : '#f39c12'}; font-weight: 600;">${escapeHtml(err.response_status || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px; text-align: center; color: #e74c3c; font-weight: 600;">${escapeHtml(err.process_status || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px; font-size: 13px; color: #7f8c8d;">${escapeHtml(moment(err.created_at).format('DD.MM.YYYY HH:mm:ss') || '-')}</td>
                        <td style="border: 1px solid #e0e0e0; padding: 8px; color: #e74c3c; font-size: 13px; max-width: 300px;">
                        <div
                            style="
                            max-height: 100px;
                            overflow-y: auto;
                            overflow-x: hidden;
                            word-break: break-word;
                          
                            font-family: monospace;
                            font-size: 13px;
                            "
                        >
                        ${(err.error_detail || '-')
                        .split(',')
                        .map(item => `<div>${escapeHtml(item.trim())}</div>`)
                        .join('')
                    }
                        </div>
                        </td>
                    </tr>
                `;
            });

            bodyContent += `
                    </tbody>
                </table>
            `;
        });

        const html = `
            <!DOCTYPE html>
            <html>
                <head>
                    <meta charset="UTF-8" />
                    <title>HAL Hata Özeti</title>
                    <style>
                        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; color: #2c3e50; margin: 20px; background: #f5f7fa; }
                        .container { max-width: 100%; margin: 0 auto; background: white; padding: 24px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
                        h2 { color: #34495e; margin: 0 0 8px 0; font-size: 22px; font-weight: 700; }
                        .summary { background: #ecf0f1; padding: 12px; border-radius: 4px; margin: 16px 0; }
                        .summary-text { margin: 0; color: #2c3e50; font-weight: 600; }
                        .summary-count { color: #e74c3c; font-weight: 700; }
                    </style>
                </head>
                <body>
                    <div class="container">
                        <h2>HAL → UKLOJISTIK Hata Özeti</h2>
                        <div class="summary">
                            <p class="summary-text">
                                Toplam Hata: <span class="summary-count">${totalErrors}</span> kayıt
                            </p>
                        </div>
                        ${bodyContent}
                    </div>
                </body>
            </html>
        `;

        return html;
    };

    // Hata özeti göster
    const handleShowErrorSummary = () => {
        if (!dataSource || dataSource.length === 0) {
            toast.warning('Önce log kayıtlarını listeleyiniz');
            return;
        }

        const htmlContent = buildErrorEmailHtml(dataSource);
        setErrorSummaryHtml(htmlContent);
        setErrorSummaryModalOpen(true);
    };

    // Attempt count güncelleme modalını aç
    const handleOpenAttemptCountModal = (rowData) => {
        // Validasyonlar
        if (rowData.process_status !== 'PENDING') {
            toast.error('Sadece PENDING statüsündeki kayıtlar güncellenebilir');
            return;
        }

        if (rowData.target_system === 'UKLOJISTIK') {
            toast.error('Kaynak Sistem UKLOJISTIK olan kayıtlar güncellenemez');
            return;
        }

        setSelectedLogForUpdate(rowData);
        setNewAttemptCount(rowData.attempt_count || '');
        setAttemptCountModalOpen(true);
    };

    // Attempt count güncelle
    const handleUpdateAttemptCount = async () => {
        if (!selectedLogForUpdate) return;

        // Validasyonlar
        const attemptCountNum = parseInt(newAttemptCount);
        if (isNaN(attemptCountNum) || attemptCountNum <= 0) {
            toast.error('Deneme sayısı 0\'dan büyük bir sayı olmalıdır');
            return;
        }
        if (attemptCountNum > 10) {
            toast.error('Deneme sayısı 10\'dan büyük olamaz');
            return;
        }

        try {
            setUpdatingAttemptCount(true);
            const body = {
                id: selectedLogForUpdate.id,
                attempt_count: attemptCountNum
            };

            await api.post('/hal/updateApiLogAttemptCount', body);
            toast.success('Deneme sayısı başarıyla güncellendi');

            // Modal'ı kapat
            setAttemptCountModalOpen(false);
            setSelectedLogForUpdate(null);
            setNewAttemptCount('');

            // Veriyi tekrar çek
            await handleSearch();
        } catch (error) {
            console.error('Attempt count update error:', error);
            toast.error(error?.response?.data?.message || 'Deneme sayısı güncellenirken hata oluştu');
        } finally {
            setUpdatingAttemptCount(false);
        }
    };

    const onCellPrepared = useCallback((e) => {
        if (e.rowType !== 'data') return;

        // Response status'a göre renklendirme
        if (e.column?.dataField === 'response_status' && e.cellElement) {
            const status = e.data?.response_status;
            if (status >= 200 && status < 300) {
                e.cellElement.style.backgroundColor = '#d4edda';
                e.cellElement.style.color = '#155724';
                e.cellElement.style.fontWeight = '500';
            } else if (status >= 400 && status < 500) {
                e.cellElement.style.backgroundColor = '#f8d7da';
                e.cellElement.style.color = '#721c24';
                e.cellElement.style.fontWeight = '500';
            } else if (status >= 500) {
                e.cellElement.style.backgroundColor = '#f5c6cb';
                e.cellElement.style.color = '#721c24';
                e.cellElement.style.fontWeight = 'bold';
            }
        }

        // Error detail varsa satırı vurgula
        if (e.data?.error_detail && e.rowElement) {
            e.rowElement.style.backgroundColor = '#fff3cd';
        }

    }, []);

    return (
        <>
            <Breadcrumb current="HAL API Logları" />
            <div className="p-3">
                <Card className="mb-3">
                    <CardBody className="p-3">
                        <Row className="mb-3">
                            <Col md="4">
                                <FormGroup className='m-0'>
                                    <DateRangeBox
                                        id="date-range-logs"
                                        displayFormat="dd.MM.yyyy"
                                        startDateLabel="Başlangıç"
                                        endDateLabel="Bitiş"
                                        showClearButton={true}
                                        value={dateRange}
                                        onValueChanged={(e) => {
                                            if (e.value && e.value.length === 2) {
                                                setDateRange(e.value);
                                            } else {
                                                // Clear edildiğinde son 1 ayı tekrar ayarla
                                                const endDate = moment();
                                                const startDate = moment().subtract(1, 'month');
                                                setDateRange([startDate.toDate(), endDate.toDate()]);
                                            }
                                        }}

                                    />
                                </FormGroup>
                            </Col>
                            <Col md="2" className="d-flex align-items-end">
                                <Button
                                    color="primary"
                                    onClick={handleSearch}
                                    disabled={loading || !dateRange}
                                    style={{ width: '100%', marginRight: '8px' }}
                                >
                                    {loading ? (
                                        <>
                                            <i className="fa fa-spinner fa-spin mr-2"></i>
                                            Yükleniyor...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search mr-2"></i>
                                            Listele
                                        </>
                                    )}
                                </Button>
                            </Col>
                            <Col md="2" className="d-flex align-items-end">
                                <Button
                                    color="danger"
                                    onClick={handleShowErrorSummary}
                                    disabled={loading || !dataSource || dataSource.length === 0}
                                    style={{ width: '100%' }}
                                >
                                    <i className="fa fa-exclamation-triangle mr-2"></i>
                                    Hata Özeti
                                </Button>
                            </Col>

                        </Row>

                        <DataGrid
                            ref={gridRef}
                            dataSource={dataSource}
                            showBorders={true}
                            showRowLines={true}
                            groupPanel={{
                                visible: true,
                                emptyPanelText: "Gruplamak için sütun başlığını buraya sürükleyin",
                                allowColumnDragging: true,
                                showWhenGrouped: true,
                                texts: {
                                    groupByThisColumn: "Bu sütuna göre grupla",
                                    groupContinuedMessage: "Devamı için buraya tıklayın",
                                    groupContinuesMessage: "Devamı için buraya tıklayın",
                                }
                            }}
                            grouping={{
                                autoExpandAll: isAllExpanded,
                                expandMode: 'rowClick'
                            }}
                            showColumnLines={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            height="calc(100vh - 300px)"
                            onCellPrepared={onCellPrepared}
                            // keyExpr={(data) => `${data.vin}_${data.created_at}`}
                            className="data-grid-gray"
                        >

                            <LoadPanel enabled={loading} />
                            <Scrolling mode="virtual" rowRenderingMode="virtual" />
                            <Sorting mode="multiple" />
                            <FilterRow visible={true} />

                            <Column
                                caption='ID'
                                dataField='id'
                                width={70}
                                alignment="center"
                            />

                            <Column
                                dataField="vin"
                                caption="Şase"
                                width={170}
                                alignment="center"
                            />
                            <Column
                                dataField="message_type"
                                minWidth={75}
                                caption="Mesaj Tipi"
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Mesaj <br /> Tipi
                                        </>
                                    );
                                }}
                                alignment="center"
                            />
                            <Column
                                dataField="source_system"
                                caption="Kaynak Sistem"
                                width={95}
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Kaynak <br /> Sistem
                                        </>
                                    );
                                }}
                                alignment="center"
                            />
                            <Column
                                dataField="target_system"
                                caption="Hedef Sistem"
                                minWidth={90}
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Hedef <br /> Sistem
                                        </>
                                    );
                                }}
                                alignment="center"
                            />
                            <Column
                                dataField="request_payload"
                                caption="Request Payload"
                                calculateDisplayValue={(e) => {
                                    return e.request_payload ? JSON.stringify(e.request_payload) : '-';
                                }}
                                minWidth={90}
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Request <br /> Payload
                                        </>
                                    );
                                }}
                                alignment="center"
                                cellRender={(e) => {
                                    if (!e.value) return '-';
                                    return (
                                        <Button
                                            color="info"
                                            size="sm"
                                            onClick={() => {
                                                setSelectedPayload(e.value);
                                                setPayloadModalOpen(true);
                                            }}
                                            style={{
                                                fontSize: '11px',
                                                padding: '4px 8px'
                                            }}
                                        >
                                            <i className="fa fa-eye mr-1"></i>
                                            Detay
                                        </Button>
                                    );
                                }}
                            />
                            <Column
                                dataField="response_status"
                                caption="Status"
                                width={100}
                                alignment="center"
                            />
                            <Column
                                dataField="process_status"
                                caption="Process Status"
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Process <br /> Status
                                        </>
                                    );
                                }}
                                width={100}
                                alignment="center"
                            />
                            <Column
                                dataField="attempt_count"
                                caption="Deneme Sayısı"
                                width={85}
                                alignment="center"
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Deneme <br /> Sayısı
                                        </>
                                    );
                                }}
                                cellRender={(e) => {
                                    const hasNot = e.data?.not && Array.isArray(e.data.not) && e.data.not.length > 0;

                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
                                            <span style={{ fontWeight: '500' }}> &nbsp;{e.value || 0}</span>
                                            {hasNot ? (
                                                <i
                                                    className="fa fa-info-circle"
                                                    style={{
                                                        color: '#17a2b8',
                                                        cursor: 'pointer',
                                                        fontSize: '16px'
                                                    }}
                                                    onClick={() => {
                                                        setSelectedNot(e.data.not);
                                                        setNotModalOpen(true);
                                                    }}
                                                    title="Deneme sayısı geçmişi"
                                                />
                                            ) : (<span></span>)}
                                        </div>
                                    );
                                }}
                            />

                            <Column
                                dataField="response_payload"
                                caption="Response Payload"
                                minWidth={90}
                                calculateDisplayValue={(e) => {

                                    return e.response_payload ? JSON.stringify(e.response_payload) : '-';
                                }}
                                headerCellRender={() => {
                                    return (
                                        <>
                                            Response <br /> Payload
                                        </>
                                    );
                                }}
                                alignment="center"
                                cellRender={(e) => {
                                    if (!e.value) return <span style={{ color: '#999' }}>-</span>;
                                    return (
                                        <Button
                                            color="info"
                                            size="sm"
                                            onClick={() => {
                                                setSelectedResponsePayload(e.value);
                                                setResponsePayloadModalOpen(true);
                                            }}
                                            style={{
                                                fontSize: '11px',
                                                padding: '4px 8px'
                                            }}
                                        >
                                            <i className="fa fa-eye mr-1"></i>
                                            Detay
                                        </Button>
                                    );
                                }}
                            />
                            <Column
                                dataField="error_detail"
                                caption="Hata Detayı"
                                minWidth={80}
                                alignment="center"
                                cellRender={(e) => {
                                    if (!e.value) return <span style={{ color: '#999' }}>-</span>;
                                    return (
                                        <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => {
                                                setSelectedError(e.value);
                                                setErrorModalOpen(true);
                                            }}
                                            style={{
                                                fontSize: '11px',
                                                padding: '4px 8px'
                                            }}
                                        >
                                            <i className="fa fa-exclamation-circle mr-1"></i>
                                            Detay
                                        </Button>
                                    );
                                }}
                            />
                            <Column
                                dataField="created_at"
                                caption="Oluşturulma Tarihi"
                                width={165}
                                alignment="center"
                                dataType="datetime"
                                format="dd.MM.yyyy HH:mm:ss"
                            />

                            <Column
                                dataField="updated_at"
                                caption="Güncelleme Tarihi"
                                width={160}
                                alignment="center"
                                dataType="datetime"
                                format="dd.MM.yyyy HH:mm:ss"

                            />
                            <Column
                                dataField="triggered_by"
                                caption="Ekleyen"
                                width={100}
                                alignment="center"
                            />
                            <Column
                                caption="İşlem"
                                width={100}
                                alignment="center"
                                cellRender={(e) => {
                                    const canEdit = e.data?.process_status === 'PENDING' &&
                                        e.data?.target_system !== 'UKLOJISTIK';

                                    if (!canEdit) {
                                        return <span style={{ color: '#999' }}>-</span>;
                                    }

                                    return (
                                        <Button

                                            size="sm"
                                            onClick={() => handleOpenAttemptCountModal(e.data)}
                                            style={{
                                                fontSize: '13px',
                                                padding: '4px 10px'
                                            }}
                                            title="Deneme sayısını güncelle"
                                        >
                                            <i className="fa fa-edit mr-1"></i>

                                        </Button>
                                    );
                                }}
                            />
                            <Summary
                                totalItems={[{
                                    column: 'vin',
                                    summaryType: 'count'
                                }]}
                                groupItems={[{
                                    column: 'vin',
                                    summaryType: 'count',
                                    displayFormat: "{0}"
                                }]}

                            />
                            <Toolbar>
                                <Item name="groupPanel" location="before" />
                                <Item location='after'>
                                    <Tooltip
                                        target="#expand-all-button"
                                        showEvent="mouseenter"
                                        hideEvent="mouseleave"
                                        position={{ my: "bottom", at: "top" }}
                                    >
                                        <div style={{ fontSize: '12px', lineHeight: '1.5' }}>
                                            Tabloda gruplama yapıldığında tüm grupları tek seferde {isAllExpanded ? 'kapatır' : 'açar'}
                                        </div>
                                    </Tooltip>

                                    <button
                                        id="expand-all-button"
                                        onClick={() => setIsAllExpanded(prev => !prev)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "36px",
                                            height: "36px",
                                            padding: "0",
                                            border: "1px solid #d0d7de",
                                            borderRadius: "6px",
                                            backgroundColor: isAllExpanded ? "#f6f8fa" : "#ffffff",
                                            color: "#24292f",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            transition: "all 0.2s ease",
                                            boxShadow: "0 1px 0 rgba(27, 31, 36, 0.04)"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#f3f4f6";
                                            e.currentTarget.style.borderColor = "#d1d5db";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = isAllExpanded ? "#f6f8fa" : "#ffffff";
                                            e.currentTarget.style.borderColor = "#d0d7de";
                                        }}
                                    // title={isAllExpanded ? 'Tüm grupları kapat' : 'Tüm grupları aç'}
                                    >
                                        <i className={`fa ${isAllExpanded ? "fa-chevron-up" : "fa-chevron-down"}`} />
                                    </button>

                                </Item>
                                <Item location='after'>
                                    <ExportButton
                                        refValue={gridRef}
                                        title='HAL API Logları'
                                    />
                                </Item>
                            </Toolbar>
                        </DataGrid>
                    </CardBody>
                </Card>
            </div>

            {/* Request Payload Modal */}
            <Draggable handle='.modal-header'>
                <Modal
                    isOpen={payloadModalOpen}
                    toggle={() => {
                        setPayloadModalOpen(false);
                        setSelectedPayload(null);
                    }}
                    size="lg"

                    centered
                >
                    <ModalHeader
                        style={{ cursor: 'move' }}
                        className='modal-header'
                        toggle={() => {
                            setPayloadModalOpen(false);
                            setSelectedPayload(null);
                        }}>
                        Request Payload Detayı
                    </ModalHeader>
                    <ModalBody style={{ padding: '20px' }}>
                        {selectedPayload && (
                            <div style={{
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #dee2e6',
                                borderRadius: '4px',
                                padding: '15px',
                                maxHeight: '60vh',
                                overflow: 'auto',
                                fontSize: '13px',
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: '1.6'
                            }}>
                                {JSON.stringify(selectedPayload, null, 2)}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setPayloadModalOpen(false);
                                setSelectedPayload(null);
                            }}
                        >
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>

            {/* Error Detail Modal */}
            <Draggable handle='.modal-header-2'>
                <Modal
                    isOpen={errorModalOpen}
                    toggle={() => {
                        setErrorModalOpen(false);
                        setSelectedError(null);
                    }}
                    size="lg"
                >
                    <ModalHeader
                        style={{ cursor: 'move' }}
                        className='modal-header-2' toggle={() => {
                            setErrorModalOpen(false);
                            setSelectedError(null);
                        }}>
                        Hata Detayı
                    </ModalHeader>
                    <ModalBody style={{ padding: '20px' }}>
                        {selectedError && (
                            <div
                                style={{
                                    backgroundColor: '#f8d7da',
                                    border: '1px solid #f5c6cb',
                                    borderRadius: '4px',
                                    padding: '15px',
                                    maxHeight: '60vh',
                                    overflow: 'auto',
                                    fontSize: '13px',
                                    fontFamily: 'monospace',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    lineHeight: '1.6',
                                    color: '#721c24'
                                }}
                            >
                                {(selectedError || '-')
                                    .split(',')
                                    .map((item, index) => (
                                        <div key={index}>
                                            {item.trim()}
                                        </div>
                                    ))}
                            </div>

                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setErrorModalOpen(false);
                                setSelectedError(null);
                            }}
                        >
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>
            {/* Response Payload Modal */}
            <Draggable handle='.modal-header-3'>


                <Modal
                    isOpen={responsePayloadModalOpen}
                    toggle={() => {
                        setResponsePayloadModalOpen(false);
                        setSelectedResponsePayload(null);
                    }}
                    size="lg"
                    centered
                >
                    <ModalHeader
                        style={{ cursor: 'move' }}
                        className='modal-header-3' toggle={() => {
                            setResponsePayloadModalOpen(false);
                            setSelectedResponsePayload(null);
                        }}>
                        Response Payload Detayı
                    </ModalHeader>
                    <ModalBody style={{ padding: '20px' }}>
                        {selectedResponsePayload && (
                            <div style={{
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #dee2e6',
                                borderRadius: '4px',
                                padding: '15px',
                                maxHeight: '60vh',
                                overflow: 'auto',
                                fontSize: '13px',
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: '1.6'
                            }}>
                                {JSON.stringify(selectedResponsePayload, null, 2)}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setResponsePayloadModalOpen(false);
                                setSelectedResponsePayload(null);
                            }}
                        >
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>
            {/* Error Summary Modal */}
            <Draggable handle='.modal-header-4'>
                <Modal
                    isOpen={errorSummaryModalOpen}
                    toggle={() => {
                        setErrorSummaryModalOpen(false);
                        setErrorSummaryHtml(null);
                    }}
                    size="lg"
                    style={{ minWidth: '90vw' }}
                    centered
                >
                    <ModalHeader
                        style={{ cursor: 'move' }}
                        className='modal-header-4' toggle={() => {
                            setErrorSummaryModalOpen(false);
                            setErrorSummaryHtml(null);
                        }}>
                        HAL Hata Özeti
                    </ModalHeader>
                    <ModalBody style={{ padding: '0' }}>
                        {errorSummaryHtml && (
                            <iframe
                                title="Hata Özeti"
                                srcDoc={errorSummaryHtml}
                                style={{
                                    width: '100%',
                                    height: '70vh',
                                    border: 'none',
                                    display: 'block'
                                }}
                            />
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setErrorSummaryModalOpen(false);
                                setErrorSummaryHtml(null);
                            }}
                        >
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>
            {/* Attempt Count Update Modal */}
            <Draggable handle='.modal-header-5'>
                <Modal
                    isOpen={attemptCountModalOpen}
                    toggle={() => {
                        setAttemptCountModalOpen(false);
                        setSelectedLogForUpdate(null);
                        setNewAttemptCount('');
                    }}
                    centered
                    style={{ minWidth: '50vw' }}
                >
                    <ModalHeader style={{ cursor: 'move' }} className='modal-header-5' toggle={() => {
                        setAttemptCountModalOpen(false);
                        setSelectedLogForUpdate(null);
                        setNewAttemptCount('');
                    }}>
                        Deneme Sayısı Güncelle
                    </ModalHeader>
                    <ModalBody style={{ padding: '20px' }}>
                        {selectedLogForUpdate && (
                            <>
                                <Row className="mb-3">
                                    <Col md="12">
                                        <div style={{
                                            backgroundColor: '#f8f9fa',
                                            padding: '12px',
                                            borderRadius: '4px',
                                            marginBottom: '15px'
                                        }}>
                                            <div><strong>ID:</strong> {selectedLogForUpdate.id}</div>
                                            <div><strong>Şase:</strong> {selectedLogForUpdate.vin || '-'}</div>
                                            <div><strong>Mesaj Tipi:</strong> {selectedLogForUpdate.message_type || '-'}</div>
                                            <div><strong>Mevcut Deneme Sayısı:</strong> {selectedLogForUpdate.attempt_count || 0}</div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="12">
                                        <div style={{
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffc107',
                                            borderRadius: '4px',
                                            padding: '12px',
                                            marginBottom: '15px'
                                        }}>
                                            <div style={{ marginBottom: '8px' }}>
                                                <i className="fa fa-info-circle mr-2" style={{ color: '#856404' }}></i>
                                                <strong style={{ color: '#856404' }}>Bilgilendirme:</strong>
                                            </div>
                                            <div style={{ fontSize: '13px', color: '#856404', lineHeight: '1.6' }}>
                                                <div>• Sistem maksimum 10 deneme yapar.</div>
                                                <div>• 10 denemede işlem başarısız olursa sistem bir daha deneme yapmaz.</div>
                                                <div>• Deneme sayısı 10 olarak ayarlanırsa, sistem bu hatayı bir daha denemez.</div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label for="attemptCount">Yeni Deneme Sayısı <span style={{ color: 'red' }}>*</span></Label>
                                            <Input
                                                type="number"
                                                id="attemptCount"
                                                min="1"
                                                max="10"
                                                value={newAttemptCount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === '' || (parseInt(value) >= 1 && parseInt(value) <= 10)) {
                                                        setNewAttemptCount(value);
                                                    }
                                                }}
                                                placeholder="Deneme sayısını giriniz (1-10)"
                                                disabled={updatingAttemptCount}
                                            />
                                            <small className="form-text text-muted">
                                                Deneme sayısı 1 ile 10 arasında olmalıdır. 10 girilirse sistem bir daha deneme yapmaz.
                                            </small>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setAttemptCountModalOpen(false);
                                setSelectedLogForUpdate(null);
                                setNewAttemptCount('');
                            }}
                            disabled={updatingAttemptCount}
                        >
                            İptal
                        </Button>
                        <Button
                            color="primary"
                            onClick={handleUpdateAttemptCount}
                            disabled={updatingAttemptCount || !newAttemptCount}
                        >
                            {updatingAttemptCount ? (
                                <>
                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                    Güncelleniyor...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-save mr-2"></i>
                                    Güncelle
                                </>
                            )}
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>
            {/* Not Detail Modal */}
            <Draggable handle='.modal-header-6'>


                <Modal
                    isOpen={notModalOpen}
                    toggle={() => {
                        setNotModalOpen(false);
                        setSelectedNot(null);
                    }}
                    size="lg"
                    centered
                >
                    <ModalHeader
                        style={{ cursor: 'move' }}
                        className='modal-header-6'
                        toggle={() => {
                            setNotModalOpen(false);
                            setSelectedNot(null);
                        }}>
                        Deneme Sayısı Geçmişi
                    </ModalHeader>
                    <ModalBody style={{ padding: '20px' }}>
                        {selectedNot && Array.isArray(selectedNot) && selectedNot.length > 0 ? (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                            <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Tarih</th>
                                            <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', color: '#495057' }}>Kullanıcı</th>
                                            <th style={{ padding: '10px', textAlign: 'center', fontWeight: '600', color: '#495057' }}>Eski</th>
                                            <th style={{ padding: '10px', textAlign: 'center', fontWeight: '600', color: '#495057' }}>Yeni</th>
                                            <th style={{ padding: '10px', textAlign: 'center', fontWeight: '600', color: '#495057' }}>Process Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedNot.map((notItem, index) => {
                                            const getStatusColor = (status) => {
                                                if (!status) return '#6c757d';
                                                const upperStatus = status.toUpperCase();
                                                if (upperStatus === 'SUCCESS') return '#28a745';
                                                if (upperStatus === 'FAILED') return '#dc3545';
                                                if (upperStatus === 'PENDING') return '#ffc107';
                                                return '#6c757d';
                                            };

                                            return (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                                                        borderBottom: '1px solid #dee2e6'
                                                    }}
                                                >
                                                    <td style={{ padding: '10px', color: '#495057' }}>
                                                        {moment(notItem.date).format('DD.MM.YYYY HH:mm:ss')}
                                                    </td>
                                                    <td style={{ padding: '10px', color: '#495057' }}>
                                                        {notItem.user_name || notItem.user || '-'}
                                                    </td>
                                                    <td style={{ padding: '10px', textAlign: 'center', color: '#dc3545', fontWeight: '600' }}>
                                                        {notItem.old || '-'}
                                                    </td>
                                                    <td style={{ padding: '10px', textAlign: 'center', color: '#28a745', fontWeight: '600' }}>
                                                        {notItem.new || '-'}
                                                    </td>
                                                    <td style={{
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        color: getStatusColor(notItem.process_status),
                                                        fontWeight: '600'
                                                    }}>
                                                        {notItem.process_status || '-'}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
                                Geçmiş kaydı bulunamadı.
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                setNotModalOpen(false);
                                setSelectedNot(null);
                            }}
                        >
                            Kapat
                        </Button>
                    </ModalFooter>
                </Modal>
            </Draggable>
        </>
    );
};

export default HalApiLogs;

